import { deleteDoc, doc } from 'firebase/firestore';
import { ID } from 'shared/types/id';

import { CollectionOptions, getCollection } from './helpers';

export const deleteExternalConnection = (id: ID) => {
  const externalConnectionCollection = getCollection(
    CollectionOptions.ExternalConnections,
  );
  const docRef = doc(externalConnectionCollection, id);

  deleteDoc(docRef);
};
